<template>
    <a-modal id="ArchiveModal" :footer="null" :closable="false" :header="null" :visible="true">
        <div class="archive-modal-cancel" @click="handleCancel">
            <span class="md-icon" style="color: #ec4b1d; cursor: pointer">cancel</span>
        </div>
        <div class="archive-modal-image">
            <ArchiveModalIcan style="width: 400px; max-height: 200px" />
        </div>
        <p class="archive-modal-text">{{ description }}</p>
        <div class="archive-modal-slot">
            <slot></slot>
        </div>
        <div class="archive-modal-btn" v-if="modalBtnVisible">
            <button class="push-btn-give-up" @click="handleCancel">
                {{ btnCancelText }}
            </button>
            <button class="push-btn" @click="handleConfirm">
                {{ btnoktext }}
            </button>
        </div>
    </a-modal>
</template>
<script>
import ArchiveModalIcan from "../../Chatbot/pages/integrations/svg/ArchiveModalIcan.vue";

export default {
    name: "ArchiveModal",
    components: { ArchiveModalIcan },
    props: {
        description: {
            type: String,
            default: "",
        },
        btnoktext: {
            type: String,
            default: "Confirm",
        },
        btnCancelText: {
            type: String,
            default: "Cancel",
        },
        modalBtnVisible: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        handleCancel() {
            this.$emit("cancel");
        },
        handleConfirm() {
            this.$emit("confirm");
        },
    },
};
</script>
<style scoped lang="scss">
#ArchiveModal {
    .archive-modal-cancel {
        float: inline-end;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 30px;
        margin-top: -10px;
    }

    .archive-modal-image {
        display: flex;
        margin-bottom: 30px;
        margin-left: 25px;
        justify-content: flex-end;
    }

    .archive-modal-text {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        color: #181c32;
        margin-bottom: 20px;
        text-align: center;
    }

    .archive-modal-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 50px;

        .push-btn {
            background: #ec4b1d;
            border: none;
            outline: none;
            color: #ffffff;
            font-size: 14px;
            font-weight: 500;
            padding: 10px 20px;
            border-radius: 4px;
        }

        .push-btn-give-up {
            background: transparent;
            border: 1px solid #ec4b1d;
            outline: none;
            color: #ec4b1d;
            font-size: 14px;
            font-weight: 500;
            padding: 10px 20px;
            border-radius: 4px;
        }
    }

    .archive-modal-slot {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
    }
}
</style>
